"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBoolean = void 0;
function validateBoolean(_a) {
    var value = _a.value;
    return { valid: typeof value === "boolean" };
}
exports.validateBoolean = validateBoolean;
